import { IElementsProvider } from "./IElementsProvider";
import { Product } from '@/store/modules/product';
import { ElementMenuItem } from '../elementMenuItem';
import { Vector2 } from '@babylonjs/core';
import { ElementType, SpecyficType } from '../element';

class DressingElementsProvider implements IElementsProvider {

    public get(product: Product): ElementMenuItem[] {
        return [
            new ElementMenuItem(
                'ikony_Szuflada_mala.svg',
                'dressingShortDrawer',
                'b_s_1.gltf',
                '',
                'b_s_1_komora_light.jpg',
                new Vector2(1, 1),
                ElementType.INSIDE,
                SpecyficType.DRAWER,
            ),
            new ElementMenuItem(
                'ikony_Szuflada_duza.svg',
                'dressingLongDrawer',
                'b_s_2.gltf',
                '',
                'b_s_2_komora_light.jpg',
                new Vector2(2, 1),
                ElementType.INSIDE,
                SpecyficType.DRAWER,
            ),
        ];
    }
}

export const dressingElementsProvider = new DressingElementsProvider();